var _rect, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconGood(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1448_267971",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 12,
    height: 12
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 12,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1448_267971)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.5 10.4998V3.9998L6.5 1.0248C6.625 0.899805 6.77292 0.826888 6.94375 0.806055C7.11458 0.785221 7.27917 0.816471 7.4375 0.899805C7.59583 0.983138 7.7125 1.0998 7.7875 1.2498C7.8625 1.3998 7.87917 1.55397 7.8375 1.7123L7.275 3.9998H10.5C10.7667 3.9998 11 4.0998 11.2 4.2998C11.4 4.4998 11.5 4.73314 11.5 4.9998V5.9998C11.5 6.05814 11.4917 6.12064 11.475 6.1873C11.4583 6.25397 11.4417 6.31647 11.425 6.3748L9.925 9.89981C9.85 10.0665 9.725 10.2081 9.55 10.3248C9.375 10.4415 9.19167 10.4998 9 10.4998H3.5ZM4.5 4.4248V9.4998H9L10.5 5.9998V4.9998H6L6.675 2.2498L4.5 4.4248ZM2 10.4998C1.725 10.4998 1.48958 10.4019 1.29375 10.2061C1.09792 10.0102 1 9.7748 1 9.4998V4.9998C1 4.7248 1.09792 4.48939 1.29375 4.29355C1.48958 4.09772 1.725 3.9998 2 3.9998H3.5V4.9998H2V9.4998H3.5V10.4998H2Z",
    fill: "#757575"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconGood);
export default __webpack_public_path__ + "static/media/icon-good.f17f3574edd0a6bfcbf19510f298554f.svg";
export { ForwardRef as ReactComponent };